import React, { useState, useEffect } from 'react';
import { Button } from '../ui/Button';
import { getImagePath } from '../../Utils/Utilities';
import LoginModal from './LoginModal';


const Navbar = ({ logo = getImagePath('/Images/QikERP.png'), onLoginClick, isFromGQik = false, onBuyNowClick, showBuyNow = false, onBuyNow, isButtonPrior = true, isFromIdx = false, onLogin, loginModalOpen, onLoginModalOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hideNavbar, setHideNavbar] = useState(true);
  const [availableLinks, setAvailableLinks] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);

      // Get hero section or intro section
      if (window.innerWidth < 768) { // Only for mobile
        const heroSection = document.getElementById('hero-section');
        const introDemo = document.getElementById('introDemo');
        const targetSection = heroSection || introDemo;

        if (targetSection) {
          // Pages with hero section: hide until 25% of that section
          const sectionHeight = targetSection.offsetHeight;
          const threshold = targetSection.offsetTop + (sectionHeight * 0.10);
          setHideNavbar(window.scrollY < threshold);
        } else {
          // Pages without hero section (e.g. /demo, /feedback): show after any scroll
          setHideNavbar(window.scrollY < 10);
        }
      } else {
        setHideNavbar(false); // Always show on desktop
      }
    };

    handleScroll(); // Check on mount
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Check which sections exist on the page
    const allNavLinks = [
      { name: 'Home', href: '#hero-section' },
      { name: 'Introduction', href: '#introDemo' },
      { name: 'Product Preview', href: '#productReview' },
      { name: 'Quick Intro', href: '#demoSection' },
      { name: 'Features', href: '#ProductFeatures' },
      { name: 'Pricing', href: '#simplePricing' },
      { name: 'About', href: '#bzvzTeam' },
      { name: 'FAQ', href: '#faqSection' },
      { name: 'Contact', href: '#letsConnect' },
    ];

    const links = allNavLinks.filter(link => {
      const sectionId = link.href.substring(1);
      return document.getElementById(sectionId) !== null;
    });

    setAvailableLinks(links);
  }, []);

  const navLinks = availableLinks;

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setIsMenuOpen(false);

    const targetId = href.substring(1);
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
      const navbarHeight = 70;
      const targetPosition = targetSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-white shadow-[0_2px_10px_rgba(0,0,0,0.1)] transition-transform duration-300 ${hideNavbar ? '-translate-y-full md:translate-y-0' : 'translate-y-0'
        }`}
    >
      <div className=" px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-18">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <img
              src={logo}
              alt="Logo"
              className={`${logo.includes('Biziverse.png') ? 'h-10' : 'h-14'}  w-auto cursor-pointer hover:opacity-80 transition-opacity`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Desktop Menu */}
          <ul className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm font-normal text-text-secondary hover:text-text-primary transition-colors duration-200"
                >
                  {link.name}
                </a>
              </li>
            ))}
            <li>
              {(isFromGQik || showBuyNow) ? (
                <Button
                  onClick={onBuyNowClick}
                  size="sm"
                >
                  Buy Now
                </Button>
              ) : isFromIdx ? (
                <Button
                  onClick={onLoginClick}
                  size="sm"
                  variant="primary"
                >
                  Login
                </Button>
              ) : (
                <Button
                  onClick={onLoginClick}
                  size="sm"
                  variant={isButtonPrior ? 'primary' : 'outline'}
                >
                  Login
                </Button>
              )}
            </li>
          </ul>

          {/* Mobile Hamburger */}
          <div className="md:hidden flex items-center gap-2">
            {isFromIdx && (
              <Button
                onClick={() => onLoginModalOpen?.(true)}
                size="sm"
                variant="secondary"
              >
                Login
              </Button>
            )}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="flex flex-col justify-center items-center w-8 h-8 relative"
              aria-label="Toggle menu"
            >
              <span
                className={`w-6 h-0.5 bg-primary rounded transition-all duration-300 absolute ${isMenuOpen ? 'rotate-45' : '-translate-y-2'
                  }`}
              />
              <span
                className={`w-6 h-0.5 bg-primary rounded transition-all duration-300 ${isMenuOpen ? 'opacity-0' : 'opacity-100'
                  }`}
              />
              <span
                className={`w-6 h-0.5 bg-primary rounded transition-all duration-300 absolute ${isMenuOpen ? '-rotate-45' : 'translate-y-2'
                  }`}
              />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
        >
          <ul className="py-4 space-y-4">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-base font-normal text-text-secondary hover:text-text-primary transition-colors"
                >
                  {link.name}
                </a>
              </li>
            ))}
            {!isFromIdx && (
              <li>
                {(isFromGQik || showBuyNow) ? (
                  <Button
                    onClick={() => {
                      setIsMenuOpen(false);
                      onBuyNowClick?.();
                    }}
                    size="sm"
                  >
                    Buy Now
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      setIsMenuOpen(false);
                      onLoginClick?.();
                    }}
                    size="sm"
                  >
                    Login
                  </Button>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;